"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconAwardStar1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconAwardStar1, _Icon);
  function IconAwardStar1(props) {
    var _this;
    _classCallCheck(this, IconAwardStar1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconAwardStar1).call(this, props));
    _this.name = 'IconAwardStar1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "award-star-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "award-star-1_svg__path0",
      d: "M8.123 13.009a1.287 1.287 0 01-1.182-1.795L8.24 8.232 5.91 6.158a1.225 1.225 0 01-.413-.848 1.237 1.237 0 011.235-1.311H9.43L10.836.732a1.309 1.309 0 011.166-.727 1.304 1.304 0 011.146.689l.018.039L14.574 4l2.702-.001c.307 0 .602.118.832.331.242.225.381.53.393.86.014.368-.136.721-.412.966L15.76 8.232l1.296 2.981a1.288 1.288 0 01-.688 1.687 1.284 1.284 0 01-1.137-.073L12 11.008l-3.234 1.828a1.282 1.282 0 01-.643.173zm-1.386-8.01a.235.235 0 00-.163.411l2.601 2.316a.498.498 0 01.126.573l-1.443 3.313a.286.286 0 00.407.356l3.488-1.971a.502.502 0 01.492-.001l3.481 1.961a.291.291 0 00.257.019.285.285 0 00.153-.373l-1.437-3.307a.5.5 0 01.125-.572l2.598-2.317a.239.239 0 00.079-.184.23.23 0 00-.231-.224L14.245 5a.5.5 0 01-.459-.302l-1.535-3.559a.303.303 0 00-.517.027l-1.518 3.531A.497.497 0 019.758 5l-3.021-.001z"
    }), _react2.default.createElement("path", {
      className: "award-star-1_svg__path1",
      d: "M7.5 24c-1.103 0-2-.897-2-2s.897-2 2-2h.128l1.106-3.686A1.932 1.932 0 0110.478 15H11.5v-2.499a.5.5 0 011 0V15h1a1.93 1.93 0 011.759 1.293L16.372 20h.128c1.103 0 2 .897 2 2s-.897 2-2 2h-9zm0-3a1.001 1.001 0 000 2h9a1 1 0 000-2h-9zm7.828-1l-1.02-3.398a.915.915 0 00-.825-.602H10.5a.915.915 0 00-.815.623L8.672 20h6.656z"
    })));
    return _this;
  }
  return IconAwardStar1;
}(_Icon3.default);
exports.default = IconAwardStar1;